import React from 'react';
import { Layout } from './components/Layout';
import { Hero } from './components/Hero';
import { WhyNoronha, WhatMakesItDifferent, TopReasons } from './components/Features';
import { Includes, DiveSpotsSlider, Fauna, Gallery } from './components/Experience';
import { Accommodation, Investment, NonDivers, PaymentTimeline } from './components/Details';
import { FAQ } from './components/FAQ';
import { FinalCTA } from './components/FinalCTA';
export function App() {
  return <Layout data-id="element-0">
      <Hero data-id="element-1" />
      <WhyNoronha data-id="element-2" />
      <WhatMakesItDifferent data-id="element-3" />
      <TopReasons data-id="element-4" />
      <Includes data-id="element-5" />
      <DiveSpotsSlider data-id="element-6" />
      <Fauna data-id="element-7" />
      <Gallery data-id="element-8" />
      <Accommodation data-id="element-9" />
      <Investment data-id="element-10" />
      <NonDivers data-id="element-11" />
      <PaymentTimeline data-id="element-12" />
      <FAQ data-id="element-13" />
      <FinalCTA data-id="element-14" />
    </Layout>;
}